module.exports = __webpack_public_path__ + "img/3days.26f98289.png";